import { Component } from 'react';

export default class CursorIcon extends Component{
    render() {
        return (
            <svg width="interit" height="interit" viewBox="0 0 12 16" fill="inherit">
                <path d="M0.666504 0L11.3332 8.186L6.69917 8.966L9.5825 14.844L7.18517 16L4.28517 10.0807L0.666504 13.2153V0Z" fill="inherit"/>
            </svg>
        )
    }
};